import ProjectRating from './ProjectRatingContainer';

export default ProjectRating;
